import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
  Input,
  Label,
} from '@/components/ui';

interface TerminateConfirmationProps {
  subscriptionId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason?: string) => void;
  isPending: boolean;
}

export function TerminateConfirmation({
  subscriptionId,
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: TerminateConfirmationProps) {
  const { t } = useTranslation('subscriptions');
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason || undefined);
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) setReason('');
    onOpenChange(isOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('terminate.title')}</DialogTitle>
          <DialogDescription>
            {t('terminate.confirm', { subscriptionId })}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-4">
          <Label htmlFor="terminate-reason">{t('terminate.reason')}</Label>
          <Input
            id="terminate-reason"
            placeholder={t('terminate.reasonPlaceholder')}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => handleOpenChange(false)}
            disabled={isPending}
          >
            {t('terminate.cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {t('terminate.submit')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
